import { TariffService } from './tariff';
import { TariffType } from '../../schema';

export async function findAll (): Promise<Array<TariffType>> {
    return TariffService.findAll();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/tariff/tariff.find-all.ts